module.exports = __webpack_public_path__ + "img/怀柔实验室.504c7fbb.png";